import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LgvClientService, LgvUserService } from '../../core/core.module';
import { PricingStatusName, PropertyAssociationType } from '../../core/enums/property.enum';
import { LgvCompanyService } from '../../core/services/lgv-company.service';

@Component({
    selector: 'lus-prospect-property-status',
    templateUrl: './prospect-property-status.component.html',
    styleUrls: ['./prospect-property-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProspectPropertyStatusComponent implements OnInit, OnDestroy {
    @Output() goToDashboard = new EventEmitter<any>();
    properties$ = new BehaviorSubject([]);
    redStatusCount$ = new BehaviorSubject(0);
    yellowStatusCount$ = new BehaviorSubject(0);
    greenStatusCount$ = new BehaviorSubject(0);
    onDestroy$ = new Subject();
    constructor(private lgvClientService: LgvClientService,
        public lgvUserService: LgvUserService,
        public lgvCompanySvc: LgvCompanyService,
        private router: Router) { }

    ngOnInit(): void {
        this.lgvClientService.prospectProperties$.pipe(takeUntil(this.onDestroy$)).subscribe((pp) => {
            this.properties$.next(pp);
            this.redStatusCount$.next(pp?.filter(cp => cp.pricingStatus === PricingStatusName.ReadyForPricing).length);
            this.greenStatusCount$.next(pp?.filter(cp => cp.pricingStatus === PricingStatusName.ProductsSelected).length);
            this.yellowStatusCount$.next(
                pp?.filter(cp =>
                    cp.pricingStatus === PricingStatusName.PricingInfoNeededClientandProperty ||
                    cp.pricingStatus === PricingStatusName.PricingInfoNeededClient ||
                    cp.pricingStatus === PricingStatusName.PricingInfoNeededProperty).length
            );
        });
    }

    getPropertyStatusColor(pricingStatus) {
        switch (pricingStatus) {
            case PricingStatusName.ProductsSelected:
                return 'green';

            case PricingStatusName.ReadyForPricing:
                return 'red';

            case PricingStatusName.PricingInfoNeededClient:
            case PricingStatusName.PricingInfoNeededClientandProperty:
            case PricingStatusName.PricingInfoNeededProperty:
                return 'yellow';
            default:
                return '';
        }
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(null);
        this.onDestroy$.complete();
    }

    goToDashboardClicked(propertyId) {
        const property = this.lgvClientService.SnapShot$.value?.properties.find(p => p.propertyInfo?.id === propertyId);
        this.lgvClientService.setSelectedClientPropertyAndLoanScenario(property, property?.loanScenarios[0])
        this.goToDashboard.emit();
    }

    onPriceThisScenario(cp: any) {
        console.log(cp);
        const propertyId = cp?.propertyInfo?.id;
        const scenarioId = cp?.loanScenarios[0]?.id;
        const url = `/admin/pricing-search/client/${this.lgvClientService.ClientID$.value}/property/${propertyId}/loanScenario/${scenarioId}`;
        this.router.navigate([url]);
    }

}
